import { createEventEmmiter } from './event_emitter.js';
export const EventBus = createEventEmmiter();
//# sourceMappingURL=event_bus.js.map